import { render, staticRenderFns } from "./CashTake.vue?vue&type=template&id=0c486571&scoped=true&"
import script from "./CashTake.vue?vue&type=script&lang=js&"
export * from "./CashTake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c486571",
  null
  
)

export default component.exports